<template>
  <div class="flex sharing-v">
    <Header />
    <secondStep titleMsg="查看报名信息" />
    <div class="info-item">
      <h3 class="text-center">报考信息</h3>
      <div class="info-area wrapper">
        <a-row :gutter="16">
          <a-col :xs="24" :sm="12" :md="12" :lg="7" :xl="7">
            <h4>考试科目：{{ userInfo.examSubjects[0].subject }}</h4>
          </a-col>
          <a-col :xs="24" :sm="14" :md="14" :lg="8" :xl="8">
            <h4>
              考试时间：{{ userInfo.examSubjects[0].examStartDate }}至{{
                userInfo.examSubjects[0].examEndDate
              }}
            </h4>
          </a-col>
          <a-col :xs="24" :sm="10" :md="10" :lg="4" :xl="4">
            <h4>考试地点：{{ userInfo.areaName }}</h4>
          </a-col>
          <a-col :xs="24" :sm="12" :md="12" :lg="4" :xl="4">
            <h4>考试类型：补考</h4>
          </a-col>
        </a-row>
      </div>
    </div>
    <div class="info-item">
      <h3 class="text-center">身份信息</h3>
      <div class="info-area wrapper">
        <a-row :gutter="16">
          <a-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
            <h4>考生姓名：{{ userInfo.idName }}</h4>
          </a-col>
          <a-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
            <h4>性别：{{ userInfo.gender }}</h4>
          </a-col>
          <a-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
            <h4>考生身份：{{ type[userInfo.type - 1] }}</h4>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
            <h4>证件类型：{{ idPaperType[userInfo.idPaperType - 1] }}</h4>
          </a-col>
          <a-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
            <h4>证件号码：{{ userInfo.idNo }}</h4>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
            <h4>手机号码：{{ userInfo.mobile }}</h4>
          </a-col>
          <a-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
            <h4>电子邮箱：{{ userInfo.email }}</h4>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col
            :xs="24"
            :sm="12"
            :md="12"
            :lg="6"
            :xl="6"
            v-if="userInfo.type == 1"
          >
            <h4>工作单位：{{ userInfo.companyName }}</h4>
          </a-col>
          <a-col
            :xs="24"
            :sm="12"
            :md="12"
            :lg="6"
            :xl="6"
            v-if="userInfo.type == 1"
          >
            <h4>工作职位：{{ userInfo.title }}</h4>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
            <h4 v-if="userInfo.type == 2">
              就读学校：{{ userInfo.graduateSchool }}
            </h4>
            <h4 v-else>毕业学校：{{ userInfo.graduateSchool }}</h4>
          </a-col>
          <a-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
            <h4>学历：{{ degree[userInfo.academicQualification - 1] }}</h4>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col
            :xs="24"
            :sm="12"
            :md="12"
            :lg="6"
            :xl="6"
            v-if="userInfo.type == 1"
          >
            <h4>毕业时间：{{ userInfo.graduateDate }}</h4>
          </a-col>
          <a-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
            <h4>专业：{{ userInfo.major }}</h4>
          </a-col>
        </a-row>
      </div>
    </div>
    <div class="info-item">
      <h3 class="text-center">证件照片</h3>
      <div class="info-area wrapper" style="margin-bottom: 50px">
        <a-row :gutter="16">
          <a-col :xs="24" :sm="12" :md="12" :lg="6" :xl="4">
            <h4 class="img-title">证件正面</h4>
            <img
              :src="userInfo.idUrl1"
              v-lazy="userInfo.idUrl1"
              preview="1"
              :large="userInfo.idUrl1"
              alt
              preview-text="证件正面"
            />
          </a-col>
          <a-col :xs="24" :sm="12" :md="12" :lg="6" :xl="4">
            <h4 class="img-title">证件反面</h4>
            <img
              :src="userInfo.idUrl2"
              v-lazy="userInfo.idUrl2"
              preview="1"
              :large="userInfo.idUrl2"
              alt
              preview-text="证件反面"
            />
          </a-col>
          <a-col :xs="24" :sm="12" :md="12" :lg="6" :xl="4">
            <h4 class="img-title">报名照</h4>
            <div class="text-center">
              <img
                class="avatar-img"
                :src="userInfo.enrollImageURL"
                v-lazy="userInfo.enrollImageURL"
                preview="1"
                :large="userInfo.enrollImageURL"
                alt
                preview-text="报名照"
              />
            </div>
          </a-col>
          <a-col :xs="24" :sm="12" :md="12" :lg="6" :xl="4">
            <h4 class="img-title">学历证明文件</h4>
            <img
              :src="userInfo.academicQualificationURL"
              v-lazy="userInfo.academicQualificationURL"
              preview="1"
              :large="userInfo.academicQualificationURL"
              alt
              preview-text="学历证明文件"
            />
          </a-col>
          <a-col
            :xs="24"
            :sm="12"
            :md="12"
            :lg="6"
            :xl="4"
            v-if="userInfo.type == 1 && userInfo.jobURL != 'null'"
          >
            <h4 class="img-title">工作证明文件</h4>
            <img
              :src="userInfo.jobURL"
              v-lazy="userInfo.jobURL"
              preview="1"
              :large="userInfo.jobURL"
              alt
              preview-text="工作证明文件"
            />
          </a-col>
        </a-row>
      </div>
    </div>
    <!-- ---------------------承诺书 ---------------------------------------------------->
    <div
      class="info-item"
      style="margin-top: -30px"
      v-if="userInfo.areaName == '线上考试'"
    >
      <h3 class="text-center">承诺书</h3>
      <div class="info-area wrapper" style="margin-bottom: 50px">
        <a-row :gutter="16" type="flex" justify="center">
          <a-col :xs="24" :sm="12" :md="12" :lg="6" :xl="4">
            <!-- //在img标签添加preview属性 preview值相同即表示为同一组
// 如果你只想预览，不想轮播，而且刚好又是循环的，可以这样    :preview="item.id",这样就不会有相同的preview值 -->
            <img
              :src="userInfo.declareUrl"
              v-lazy="userInfo.declareUrl"
              preview="2"
              :large="userInfo.declareUrl"
              alt
              preview-text="承诺书"
            />
            <!-- <img :src="userInfo.declareUrl" alt /> -->
          </a-col>
        </a-row>
      </div>
    </div>
    <a-form-item
      class="text-center"
      style="margin-top: 20px"
      v-if="$route.query.lookMsg != 1"
    >
      <a href="/secondArea"
        ><a-button type="detault" style="margin-right: 20px"
          >上一步</a-button
        ></a
      >
      <a-button type="primary" @click="waitPay">去缴补考费</a-button>
    </a-form-item>
    <a-form-item class="text-center" style="margin-top: 20px" v-else>
      <a href="/successPay"><a-button type="primary">返回</a-button></a>
    </a-form-item>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "../components/Header";
import secondStep from "../components/common/secondStep";
import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("apply");

export default {
  name: "Login",
  components: {
    Header,
    secondStep,
  },
  data() {
    return {
      needUpdate: false,
      userInfo: {},
      degree: ["高中及以下", "专科", "本科", "硕士", "博士"],
      idPaperType: ["身份证", "临时身份证", "护照", "港澳通行证", "台湾通行证"],
      type: ["在职", "学生"],
    };
  },
  mounted() {
    // let userInfo = JSON.parse(localStorage.getItem("apply_userInfo"));
    // this.getStudentInfo({
    //   orderCode: userInfo.orderCode,
    //   userCode: userInfo.userCode,
    // }).then((res) => {
    //   let studentInfo = res.data.data;
    //   this.userInfo = studentInfo;
    //   this.$previewRefresh();
    // });
    let userInfo = JSON.parse(localStorage.getItem("second_userInfo"));
    this.secondStuMsg({
      examCode: userInfo.examCode,
      userCode: userInfo.userCode,
    }).then((res) => {
      let studentInfo = res.data.data;
      this.userInfo = studentInfo;
      this.$previewRefresh();
    });
  },
  methods: {
    ...mapActions(["getStudentInfo", "updateStudentAction", "judgeOrderStatus", "secondStuMsg"]),
    waitPay() {
      let userInfo = JSON.parse(localStorage.getItem("second_userInfo"));
      this.judgeOrderStatus({ userCode: userInfo.userCode, examCode: userInfo.examCode }).then((res) => {
        if (res.data.status == 2000) {
          this.$router.push("/waitPay")
        } else {
          this.$warning({
            title: res.data.message,
            content: res.data.message,
            okText: "知道了",
            okType: "primary",
            maskClosable: true,
            onOk() { },
            onCancel() { },
          });
        }
      });

    },
    submitAudit() {
      let data = {};
      let userInfo = JSON.parse(localStorage.getItem("studentInfo"));
      // if(userInfo.currentStatus ==10) return
      data.enrollInfoId = userInfo.enrollInfoId;
      data.examCode = userInfo.examCode;
      data.updateType = 6;
      data.orderCode = userInfo.orderCode;

      let formData = new FormData();

      Object.keys(data).map((item) => {
        formData.append(item, data[item]);
      });
      this.updateStudentAction(formData).then((res) => {
        if (res.data.status == 2000) {
          this.$router.push("/result");
        } else {
          this.$warning({
            title: res.data.message,
            content: res.data.message,
            okText: "知道了",
            okType: "primary",
            maskClosable: true,
            onOk() { },
            onCancel() { },
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.next-box {
  margin-top: 30px;
  justify-content: center;
}
.info-item {
  margin-top: 20px;
}
.info-item h3 {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
}
.info-area {
  padding: 30px;
  background: #f9f9f9;
  border: 1px solid #d8d8d8;
}
.info-area h4 {
  font-weight: bold;
  text-align: left;
}
.info-area img {
  width: 100%;
}
.info-area .img-title {
  text-align: center;
  margin: 15px 0 10px;
}
.info-area .avatar-img {
  width: 100px;
}
img {
  cursor: pointer;
}
.pswp__caption__center {
  font-size: 28px;
  text-align: center;
}
</style>